import '../../generic_social_content_view.js.coffee'
Namespace 'Monitoring.Views.SocialContents'

class Monitoring.Views.SocialContents.SocialContentView extends Monitoring.Views.GenericSocialContentView
  template: JST['backbone/templates/monitoring/social_contents_v2/social_content']
  tagName: 'section'
  className: 'content'

  initialize: (@options = {}) ->
    @currentUser = @options.currentUser
    @accountSettings = @options.accountSettings || {}
    @customerData = @options.customerData || {}
    @customerLinkClicked = ''
    @selectTagsElement = ''
    @chosenTagsElement = ''
    @selectGroupsElement = ''
    @chosenGroupsElement = ''
    @hasMouse = true
    @isExcluded = false
    @isEscalated = false
    @defaultChartsByAccount = @options.defaultChartsByAccount
    @newCaseToCreate = {}
    @tagsEditorIsCollapsed = true
    @groupsEditorIsCollapsed = true
    @send_to_customer = false
    @listenTo(Backbone, 'contents:finishedLoading', @displayAttachmentScroll)

  events:
    'click .delete': 'onDelete'
    'click .customer': 'onClickCustomer'
    'click #create_case': 'onClickCreateCase'
    'click #cancel_case': 'onClickCancelCase'
    'change input[name=assigned_or_not]': 'onChangeAssignedSelectorOrNote'
    'change #assigned_to_from_monitoring': 'onChangeAssignedSelectorOrNote'
    'keyup .new_case_note': 'onChangeAssignedSelectorOrNote'
    'click .view-profile': 'showProfile'
    'click .history': 'showHistory'
    'click .context': 'showContext'
    'mouseover .sc-tags .tags-editor div.chosen-container': 'onMouseoverTags'
    'mouseover .sc-groups .tags-editor div.chosen-container': 'onMouseoverGroups'
    'mouseover': 'onMouseover'
    'mouseleave': 'onMouseleave'
    'click .video-preview': 'showVideo'
    'hide [id^=modal-video]': 'pauseVideo'
    'click .audio-preview': 'showAudio'
    'hide [id^=modal-audio]': 'pauseAudio'
    'click .children-comments': '_childrenCommentsPreview'
    'click .twitter-related-children': 'twitterRelatedChildrenPreview'
    'click .sc-see-more': '_toggleShortener'
    'click .sc-view-groups': '_toggleGroups'
    'click .sc-view-tags': '_editTags'
    'click .attachment-scroll-backwards': 'scrollAttachmentsBackwards'
    'click .attachment-scroll-forwards': 'scrollAttachmentsForwards'

  innerTemplateRoute: ->
    specificities = [
      [@model.type(), @model.subType()],
      [@model.type(), @model.origin(), @model.subType()],
      [@model.groupType(), @model.type(), @model.subType()],
      [@model.groupType(), @model.type()],
      [@model.groupType()]
    ]
    templateRoutes = _.map(specificities, (s) ->
      "backbone/templates/monitoring/social_contents/#{s.join('/')}/social_content"
    )
    selectedTemplateRoute = _.find(templateRoutes, (tr) -> JST[tr])
    @_logMissingTemplate() unless selectedTemplateRoute
    selectedTemplateRoute

  _logMissingTemplate: ->
    text = "Missing template for group type #{@model.groupType()}, type #{@model.type()}, subtype #{@model.subType()}"
    console.warn(text)
    jsLogger.fatal(text)

  onMouseover: =>
    @hasMouse = true

  onMouseleave: =>
    @hasMouse = false
    @waitAndDetachTags() if @selectTagsElement == ''
    @waitAndDetachGroups() if @selectGroupsElement == ''

  onMouseoverTags: ->
    return if @$el.find('.sc-tags .tags-editor div.chosen-container').hasClass('chosen-with-drop')
    @$el.find('.sc-tags .tags-editor div.chosen-container').append(@chosenTagsElement) if @chosenTagsElement
    @chosenTagsElement = ''
    @$el.find('.sc-tags .tags-editor-possible').prepend(@selectTagsElement) if @selectTagsElement
    @selectTagsElement = ''

  waitAndDetachTags: ->
    setTimeout =>
      @detachInvisibleTagsElements() unless @hasMouse
    , 10000

  onMouseoverGroups: ->
    return if @$el.find('.sc-groups .tags-editor div.chosen-container').hasClass('chosen-with-drop')
    @$el.find('.sc-groups .tags-editor div.chosen-container').append(@chosenGroupsElement) if @chosenGroupsElement
    @chosenGroupsElement = ''
    @$el.find('.sc-groups .tags-editor-possible').prepend(@selectGroupsElement) if @selectGroupsElement
    @selectGroupsElement = ''

  waitAndDetachGroups: ->
    setTimeout =>
      @detachInvisibleGroupsElements() unless @hasMouse
    , 10000

  detachInvisibleTagsElements: ->
    @$el.find('.sc-tags .tags-editor div.chosen-container').removeClass('chosen-with-drop')
    @chosenTagsElement = @chosenTagsElement || @$el.find('.sc-tags .tags-editor div.chosen-container div.chosen-drop').detach()
    @selectTagsElement = @selectTagsElement || @$el.find('.sc-tags .tags-editor select.tags').detach()

  detachInvisibleGroupsElements: ->
    @$el.find('.sc-groups .tags-editor div.chosen-container').removeClass('chosen-with-drop')
    @chosenGroupsElement = @chosenGroupsElement || @$el.find('.sc-groups .tags-editor div.chosen-container div.chosen-drop').detach()
    @selectGroupsElement = @selectGroupsElement || @$el.find('.sc-groups .tags-editor select.tags').detach()

  showHistory: =>
    # HACK: Bootstrap does not supponrt a modal within a modal, so we need to remove the previous one before launching its modal child
    cameFromUserProfile = @$el.find('#user-profile').length > 0
    @$el.find('#user-profile').modal('hide')
    @historyView = new Monitoring.Views.SocialContentHistoryView({
      model: @model
      el: @$el.find('#social-content-history')
      onHidden: => @showProfile() if cameFromUserProfile
    })
    @historyView.show()

  showContext: =>
    @contextView.remove() if @contextView?
    contentLink = @$el.find('.content-link').length > 0 && @$el.find('.content-link')[0].href
    @contextView = Monitoring.Views.SocialContentContextView.for(@model, contentLink)
    contextContainer = @$el.find('.context-container')
    contextContainer = contextContainer[0] if contextContainer[0]?
    contextContainer.append(@contextView.render().el)
    @contextView.newSearch()

  showProfile: (event) =>
    @$el.find('#user-profile').remove()
    @userProfileView = new Customer.Users.UserProfileView
      source: @model.type()
      id: @model.userId()
      session: 'monitoring'
    @$el.append(@userProfileView.render().el)
    @userProfileView.show()

  onChangeTags: (currentlySelectedTagCodes) =>
    @model.set('tags', currentlySelectedTagCodes)
    @moderate(=> @_renderTags())

  onChangeGroups: (currentlySelectedGroups) =>
    @model.set('labels', currentlySelectedGroups)
    @moderate(=> @_renderLabels())

  moderate: (callback) =>
    new Monitoring.Models.SocialContentModerator([this]).moderate(@model.isReviewMode(), callback)

  onDelete: =>
    swal({
        title: "#{I18n.t('monitoring.dashboard.social_content.actions.delete_case.s_title')}?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: I18n.t('monitoring.dashboard.social_content.actions.delete_case.s_confirm'),
        closeOnConfirm: true
      }, =>
        new Monitoring.Models.SocialContentModerator([this]).delete()
        $(@$el).remove()
    )

  assignedSelector: ->
    @$el.find('#assigned_to_from_monitoring')

  processCustomerLink: (callbackIfNotInCustomer = $.noop) ->
    link = @customerLinkClicked || @$el.find('.customer')
    buttonText = link.text()
    linkImage = link.find('svg')

    if link.data('processed')
      return true

    assignDialog = @$el.find("#assign_from_monitoring") # modal
    assignedSelector = @assignedSelector()

    link.text('Checking...')
    $.ajax(
      type: 'POST',
      url: '/customer/api/check_if_exists.json'
      data: @basicDataForConversations()
      success: (response) =>
        @checkedIfExistsInCustomer = true
        if response.conversation && response.found
          link.data('processed', true)
          @isInCustomer = true
          if response.can_access
            link.text('Go to case').prepend(linkImage)
            link.attr('href', "/customer/dashboard#/conversation/#{response.conversation}")
          else
            link.text('Exists').prepend(linkImage)
            link.removeAttr('href')
            link.css('cursor', 'default')
          return true
        else
          @isInCustomer = false
          link.text(buttonText).prepend(linkImage)
          callbackIfNotInCustomer(assignDialog, assignedSelector)
          return false
    )

  getActiveTags: ->
    @model.set('tags', @socialContentTagsView.currentlySelectedTagCodes) if (@socialContentTagsView && @model.isReviewMode())
    @model.tags(false) # whole tags, not just codes

  getLabels: ->
    @model.set('labels', @socialContentGroupsView.currentlySelectedTagCodes) if (@socialContentGroupsView && @model.isReviewMode())
    @model.get('labels')

  getSentiment: ->
    @model.getSentiment(true) # sentiment value

  sentimentName: ->
    @model.sentiment()

  onDeleteSuccess: (data) ->
    @trigger('updateResultCount', -1)

  onClickCustomer: (evt) =>
    sc_action_div= $(evt.currentTarget.parentElement)
    if @model.isReviewMode()
      @manageSendToCustommerInReviewMode(sc_action_div)
    if !@showPopupForNewCases() && @$el.find('.create_case_li').hasClass('active')
      @$el.find('.create_case_li').removeClass('active')
      @onClickCancelCase()
      return true

    link = $(evt.currentTarget) || @$el.find('.customer')
    @customerLinkClicked = link

    if link.data('processed')
      return true

    assignDialog = @$el.find("#assign_from_monitoring")
    assignedSelector = @assignedSelector()

    if @checkedIfExistsInCustomer
      @showAssignDialogOrSkip(assignDialog, assignedSelector)
    else
      @processCustomerLink(@showAssignDialogOrSkip)

  showAssignDialog: (assignDialog, assignSelector) =>
    assignDialog.modal()
    assignSelector.chosen(width: '300px')
    setTimeout =>
      @$el.find('.new_case_note').focus()
    , 500

  showAssignDialogOrSkip: (assignDialog, assignSelector) =>
    if @showPopupForNewCases() && @send_to_customer
      @showAssignDialog(assignDialog, assignSelector)
    else
      @createConversation(false)

  createNewCase: =>
    if Object.keys(@newCaseToCreate).length == 0
      return
    link = @customerLinkClicked || @$el.find('.customer')
    buttonText = link.text()
    linkImage = link.find('svg')

    link.text('Working...')
    $.ajax(
      type: 'POST',
      url: '/customer/api/get_or_create.json'
      data: @newCaseToCreate
      success: (response) =>
        if response.conversation
          @conversation = response.conversation
          link.data('processed', true)
          if response.can_access
            link.text('Go to case').prepend(linkImage)
            link.attr('href', "/customer/dashboard#/conversation/#{response.conversation}")
          else
            link.text('Created').prepend(linkImage)
            link.removeAttr('href')
            link.css('cursor', 'default')
        else
          link.text(buttonText).prepend(linkImage)
          alert('No conversation created')
          console.log('Response from customer api:')
          console.log(response)
    )

  getDataForNewCase: ->
    @removeFromCustomerToSendIfNecessary()
    if Object.keys(@newCaseToCreate).length == 0
      return null
    else
      @newCaseToCreate

  basicDataForConversations: ->
    {content_id: @model.id, current_topic: @model.get('topics')[0].id, force: true}

  createConversationUnassigned: (note) ->
    @finishNewCaseCreation({}, note)

  createConversationAssignedToUser: (user_id, note) ->
    @finishNewCaseCreation({user_to_assign: user_id}, note)

  createConversationAssignedToUserGroup: (group_id, note) ->
    @finishNewCaseCreation({user_group_to_assign: group_id}, note)

  finishNewCaseCreation: (data, note) ->
    data.note = note if note && note.trim() != ''
    @newCaseToCreate = _.extend(@basicDataForConversations(), data)
    @changeCancelButtonText('Remove') if @model.isReviewMode()
    @createNewCase() unless @model.isReviewMode() # the creation will happen after confirming current batch

  showPopupForNewCases: ->
    @accountSettings.show_popup_on_creation

  onClickCreateCase: ->
    @createConversation()

  createConversation: (showDialog = true) ->
    if @model.isReviewMode()
      @$el.find('.create_case_li').addClass('active')
    if showDialog
      if @assignmentIsDefined()
        @createConversationAssignedTo(@assignedSelector().val(), @$el.find('.new_case_note').val())
      else
        @createConversationUnassigned(@$el.find('.new_case_note').val())
    else
      @createConversationUnassigned()

  onClickCancelCase: ->
    if @model.isReviewMode()
      @newCaseToCreate = {}
      @changeCancelButtonText('Cancel')
      @resetNewCaseModal()
      @$el.find('.create_case_li').removeClass('active')

  changeCancelButtonText: (newText) ->
    setTimeout =>
      @$el.find('#cancel_case').html(newText)
    , 500

  createConversationAssignedTo: (user_or_group, note = '') ->
    if @isUser(user_or_group)
      @createConversationAssignedToUser(user_or_group, note)
    else
      @createConversationAssignedToUserGroup(user_or_group, note)

  _childrenCommentsPreview: ->
    @searchQuery = new Monitoring.Models.SearchQuery({}, { use_defaults: false, defaultCharts: @defaultChartsByAccount })
    dashboardPreview = new Monitoring.Views.DashboardPreviewResultsView
      searchQuery: @searchQuery
      facets: {}
      defaultChart: @defaultChartsByAccount
    @$el.find('.children-preview-container').html(dashboardPreview.render().el)
    dashboardPreview.setSearchQuery(@getChildrenQuery())
    dashboardPreview.newSearch()

  getChildrenQuery: ->
    query = @searchQuery.deepCopy()
    query.addParentPostId(@model.numeric_id())
    query.removeDateFromRealtime()
    query.addDateFrom(Date.create(@model.created_at()))
    query.addDateTo(Date.now())
    return query

  twitterRelatedChildrenPreview: (event) =>
    event.stopPropagation()
    @searchQuery = new Monitoring.Models.SearchQuery({}, { use_defaults: false, defaultCharts: @defaultChartsByAccount })
    dashboardPreview = new Monitoring.Views.DashboardPreviewResultsView
      searchQuery: @searchQuery
      facets: {}
      defaultChart: @defaultChartsByAccount
      drillDownMode: true
    @$el.find('.children-preview-container').html(dashboardPreview.render().el)
    dashboardPreview.setSearchQuery(@getRelatedChildrenQuery())
    dashboardPreview.newSearch()

  getRelatedChildrenQuery: ->
    return new Monitoring.Methods.RelatedQueryBuilder(@searchQuery).getQuery(@model)

  isUser: (user_or_group) ->
    _.contains(_.pluck(@customerData.users, 'id'), parseInt(user_or_group))

  assignmentIsDefined: ->
    @mustAssign() and @userOrGroupSelected()

  mustAssign: ->
    checkbox = @$el.find('#assigned_or_not')
    if checkbox[0]
      checkbox[0].checked
    else
      false

  userOrGroupSelected: ->
    @assignedSelector().val() != "null"

  onChangeAssignedSelectorOrNote: ->
    checkboxAssigned = @$el.find('#assigned_or_not')
    assignmentDiv = @$el.find('.new_case_assignment')
    buttonCreateCase = @$el.find('#create_case')
    note = @$el.find('.new_case_note')
    if @mustAssign()
      assignmentDiv.css("visibility", "visible")
    else
      assignmentDiv.css("visibility", "hidden")
    setTimeout =>
      @$el.find('.new_case_note').focus()
    , 500
    selectionOk = (not @accountSettings.assign_cases_on_creation) or (not @mustAssign()) or @assignmentIsDefined()
    noteOk = if @accountSettings.notes_are_mandatory then (note.val() || '').trim() != '' else true
    if selectionOk and noteOk
      buttonCreateCase.attr("disabled", false).removeClass("ui-state-disabled")
    else
      buttonCreateCase.attr("disabled", true).addClass("ui-state-disabled")

  onModerationSuccess: (data) ->
    @model.set(data)
    @model.set('edit_tags', false)
    @model.set('review_mode', false)
    @_renderDetails()
    @_renderModerationStatus()

  onModerationError: (data) ->
    @model.set('edit_tags', false)
    @render()
    showError(data.errors)

  destroy: ->
    @model.destroy()
    this.remove()
    return false

  shouldBeEscalated: ->
    @isEscalated

  _renderSentiment: ->
    @sentimentView = new Monitoring.Views.SentimentView
      model: @model
      centerToolbar: true
    @$el.find('div.sentiment').html @sentimentView.render().el
    @_changeTextBackground @sentimentName().toLowerCase()
    @listenTo @sentimentView, 'sentiment:changed', @_changeTextBackground
    @$el.find('em.evidence').tooltip({
      'selector': '',
      'placement': 'bottom',
      'html': true
    })

  _changeTextBackground: (sentiment) ->
    @$el.find('.sc-text')
      .removeClass(@_sentimentHTMLClasses())
      .addClass("background-sentiment-#{sentiment.toLowerCase()}")
    @$el.find('.sentiment-icon')
      .removeClass(@_sentimentIconHTMLClasses())
      .addClass("sentiment-#{sentiment.toLowerCase()}")

  _sentimentHTMLClasses: ->
    ("background-sentiment-#{sentiment}" for sentiment in ['positive', 'negative', 'neutral', '']).join(' ')

  _sentimentIconHTMLClasses: ->
    ("sentiment-#{sentiment}" for sentiment in ['positive', 'negative', 'neutral', '']).join(' ')

  _renderTags: ->
    @loadTagsView()
    @listenTo(@socialContentTagsView, 'changed:tags', @onChangeTags)
    @$el.find('.sc-tags').html(@socialContentTagsView.render())

  _renderLabels: ->
    @loadGroupsView()
    @listenTo(@socialContentGroupsView, 'changed:tags', @onChangeGroups)
    @$el.find('.sc-groups').html(@socialContentGroupsView.render())

  loadTagsView: =>
    @socialContentTagsView = new Monitoring.Dashboard.SocialContentTagsView(
      possibleTags: @model.possibleTags()
      selectedTagCodes: @model.get('tags')
      suggestedTags: @model.suggestedTags()
      mode: if @model.isReviewMode() then 'review' else 'explore'
      withIconAndLabel: true
      toggleableControls: true
    )
    @listenTo(@socialContentTagsView, 'changed:editorVisibility', @updateTagsContainerStyle)

  loadGroupsView: =>
    @socialContentGroupsView = new Monitoring.Dashboard.SocialContentTagsView(
      possibleTags: _.map(Keepcon.groups, (group) -> {code: group, description: group})
      selectedTagCodes: @getLabels()
      suggestedTags: []
      mode: if @model.isReviewMode() then 'review' else 'explore'
      withIconAndLabel: true
      groupsInsteadOfTags: true
      toggleableControls: true
    )
    @listenTo(@socialContentGroupsView, 'changed:editorVisibility', @updateGroupsContainerStyle)

  updateTagsContainerStyle: (visible) =>
    @tagsEditorIsCollapsed = !visible
    @updateTagsAndGroupsContainerStyle()

  updateGroupsContainerStyle: (visible) =>
    @groupsEditorIsCollapsed = !visible
    @updateTagsAndGroupsContainerStyle()

  updateTagsAndGroupsContainerStyle: =>
    @$el.find('.sc-groups-and-tags-container').toggleClass('both-collapsed', @tagsEditorIsCollapsed && @groupsEditorIsCollapsed)

  render: ->
    @$el.html(@template(@_extendedModel()))
    @$el.addClass('hide') if @model.get('deleted')
    @_renderHeader()
    @_renderDetails()
    @_renderActions()
    @_renderLabels()
    @_renderTags()
    @updateTagsAndGroupsContainerStyle()
    @_renderEmailSummary()
    @_renderText()
    @_renderMedia()
    @_renderEmailAttachments()
    @_renderSentiment() # render sentiment AFTER render media container
    @detachInvisibleTagsElements()
    @detachInvisibleGroupsElements()
    @processCustomerLink() if @processLinksIsEnabledForCurrentAccount() && @customerEnabled()
    @resetNewCaseModal()
    @_hideAllActions() if @_isPreviewMode()
    @_renderModerationStatus()
    
    this

  _extendedModel: ->
    extendedModel = @model
    extendedModel.current_user = @currentUser
    extendedModel.account_settings = @accountSettings
    extendedModel.users_of_customer = @customerData.users
    extendedModel.users_groups_of_customer = @customerData.usersGroups
    extendedModel.new_case_note_placeholder = () ->
      if @account_settings.notes_are_mandatory then "Add a note (mandatory)" else "Add a note..."
    extendedModel.inner_template_route = @innerTemplateRoute()
    extendedModel

  _renderDetails: ->
    @$el.find('.sc-details').replaceWith @_detailsView().render().el

  _renderModerationStatus: ->
    status_class = "sc-status-#{@model.status_class()}"
    locale = I18n.locale

    @$el.find('.sc-container').removeClass("sc-status-approved sc-status-approved--#{locale} sc-status-rejected sc-status-rejected--#{locale}")
    @$el.find('.sc-container').addClass("#{status_class} #{status_class}--#{locale}") if @_showModeration()

  _detailsView: ->
    new Monitoring.Views.SocialContents.SocialContentDetailsView
      model: @model

  getHeaderView: (options = {}) ->
    new Monitoring.Views.SocialContents.SocialContentHeaderView(options)

  _renderHeader: ->
    return @_renderNewsCommentHeader() if @model.isClippingComment?()
    @headerView = @getHeaderView(el: @$el.find('.sc-header'), model: @model)
    @headerView.render()

  _renderNewsCommentHeader: ->
    @headerView = new Monitoring.Views.SocialContents.SocialContentNewsCommentHeaderView
      el: @$el.find('.sc-header')
      model: @model
    @headerView.render()

  _renderActions: ->
    @actionsView = new Monitoring.Views.SocialContents.SocialContentActionsView
      el: @$el.find('.sc-actions')
      model: @model
      main: this
    @actionsView.render()
    @listenTo @actionsView, 'socialContent:escalateCase', @_setEscalated
    @listenTo @actionsView, 'socialContent:deEscalateCase', @_unsetEscalated
    @listenTo @actionsView, 'socialContent:excludeCase', @_setExcluded
    @listenTo @actionsView, 'socialContent:includeCase', @_unsetExcluded

  _setEscalated: ->
    @isEscalated = true
    @$el.addClass 'escalated'
    @toggleBlockAllBut '.sc-escalation'

  manageSendToCustommerInReviewMode:(sc_action_div) ->
    @send_to_customer = !@send_to_customer
    sc_action_div.toggleClass('active')

  removeFromCustomerToSendIfNecessary: ->
    if !@send_to_customer
      @newCaseToCreate = {}

  _unsetEscalated: ->
    @isEscalated = false
    @$el.removeClass 'escalated'
    @toggleBlockAllBut '.sc-escalation'

  _setExcluded: ->
    @isExcluded = true
    @$el.addClass 'excluded'
    @toggleBlockAllBut '.sc-exclusion'

  _unsetExcluded: ->
    @isExcluded = false
    @$el.removeClass 'excluded'
    @toggleBlockAllBut '.sc-exclusion'

  resetNewCaseModal: ->
    canAssign = @accountSettings.assign_cases_on_creation
    userToAssign = @accountSettings.default_user_to_assign
    groupToAssign = @accountSettings.default_users_group_to_assign

    if canAssign and (userToAssign != 0 or groupToAssign != 0) # if a default is configured
      if userToAssign == 0
        @selectUserOrGroupToAssign(groupToAssign)
      else
        @selectUserOrGroupToAssign(userToAssign)
    @$el.find('#assigned_or_not').prop('checked', 'checked')
    @$el.find('.new_case_note').val('')
    @onChangeAssignedSelectorOrNote()
    # TODO cambiar el nombre por "Me" ?

  selectUserOrGroupToAssign: (user_or_group_id) ->
    @assignedSelector().val(user_or_group_id).trigger('chosen:updated')

  processLinksIsEnabledForCurrentAccount: ->
    @accountSettings.process_customer_links

  customerEnabled: ->
    @customerData.enabledForCurrentAccount and @_customerAllowedForThisContent()

  _customerAllowedForThisContent: ->
    (@_customerAllowedForType() or @_customerAllowedForGroupType()) and (not @_customerForbiddenForSubType())

  _customerAllowedForType: ->
    @customerData.settings.allowed_types.indexOf(@model.type()) != -1

  _customerAllowedForGroupType: ->
    @customerData.settings.allowed_group_types.indexOf(@model.groupType()) != -1

  _customerForbiddenForSubType: ->
    @customerData.settings.forbidden_sub_types.indexOf(@model.subType()) != -1

  onAvatarError: (evt) ->
    defaultAvatarPath =  window.image_path('default-avatar.gif')
    $(evt.currentTarget).attr('src', defaultAvatarPath)

  toggleBlockAllBut: (selector) ->
    elementsToBlock = [
      '.sc-links'
      '.sc-actions'
      '.sc-sentiment'
      '.sc-selector'
      '.tag'
    ].join(',')
    @$el.find(elementsToBlock).toggleClass 'unclickable'
    @$el.find(selector).toggleClass 'clickable'

  isExploreMode: ->
    $('.dashboard-modes button.active').attr('id') == 'explore'

  _renderEmailSummary: ->
    return unless @model.isEmail()
    @emailSummaryView = new Monitoring.Views.SocialContents.SocialContentEmailSummaryView
      email: @model
    @$el.find('.sc-main').prepend(@emailSummaryView.render().el)

  _renderText: ->
    _.defer @_activateShortener
    @_renderFixedContent()
    @_renderTwitterQuote() if @model.isQuote()
    @_renderRetweet() if @model.isRetweet()
    @_renderAttachments() if @_showAttachmentsBox()
    @_renderNewsText() if @model.isClippingNews?()
    @_renderNewsComment() if @model.isClippingComment?()

  _activateShortener: =>
    if @_doNotCutText()
      @$el.find('.sc-see-more').hide()
      return
    $shortener = @$el.find '.sc-text-shortener'
    if $shortener.height() > 60
      $shortener.parent().addClass 'sc-shortened'

  _doNotCutText: ->
    return true if @model.doNotCutText?()
    route = @innerTemplateRoute()
    whitelist = [
      'backbone/templates/monitoring/social_contents/inbox/JumboChileDemo/social_content',
      'backbone/templates/monitoring/social_contents/inbox/JumboColombiaDemo/social_content',
      'backbone/templates/monitoring/social_contents/inbox/NaturaLatNPS/social_content'
      'backbone/templates/monitoring/social_contents/inbox/NaturaLatamNPS/social_content'
    ]
    _.contains(whitelist, route)

  _toggleShortener: (event) ->
    $seeMore = $(event.target)
    $container = $seeMore.closest('.sc-text').toggleClass 'sc-expanded'
    $seeMore.text(I18n.t("monitoring.dashboard.social_content.#{
      if $container.hasClass('sc-expanded') then 'see_less' else 'see_more'
    }"))
    false

  _renderFixedContent: ->
    if @model.type() == "google_play" || @model.type() == "apple_app_store"
     starRating = @model.starRating()
     @responseBlockView = new Monitoring.Views.ResponseBlockView(@model)
     if (@model.isBrandContent())
       @$el.find('.sc-bottom-fixed-container').html(@responseBlockView.render().el)
       @responseBlockView.setRating(starRating) if starRating
     else
       @$el.find('.sc-top-fixed-container').html(@responseBlockView.render().el)
       @responseBlockView.setRating(starRating) if starRating

  _renderTwitterQuote: ->
    @twitterQuoteView = new Monitoring.Views.SocialContents.SocialContentQuoteView
      avatar: @model.quotedAvatar()
      author: @model.quotedAuthor()
      username: @model.quotedUserName()
      text: @model.quotedText()
    @$el.find('.sc-quote-container').html(@twitterQuoteView.render().el)

  _renderRetweet: ->
    @retweetView = new Monitoring.Views.SocialContents.SocialContentRetweetView
      contentEnhancer: @model.getContentEnhancer
      originalAuthor: @model.getOriginalAuthor()
    @$el.find('.sc-text-shortener').prepend(@retweetView.render().el)

  _renderAttachments: ->
    @attachmentsView = new Monitoring.Views.SocialContents.SocialContentAttachmentsView
      links: @model.links?()
      emailFiles: @_emailAttachments()
      facebookAttachments: @_facebookAttachments()
      webchatAttachments: @_webchatAttachments()
    @$el.find('.sc-text').append(@attachmentsView.render().el)

  _emailAttachments: ->
    return null unless @_hasEmailAttachments()
    return attachments = _.object([type, @model.getAttachments(type)] for type in ['images', 'videos', 'audios', 'applications', 'texts', 'files']) if @model.isNewEmailVersion()
    @model.getValues()['attachments']

  _webchatAttachments: ->
    return null unless @_hasWebchatAttachments()
    attachments = _.object([type, @model.getAttachments(type)] for type in ['images', 'videos', 'audios', 'files'])

  _facebookAttachments: ->
    return null unless @_hasFacebookAttachments()
    attachments = _.object([type, @model.getAttachments(type)] for type in ['images', 'videos', 'audios', 'files'])
    extend(attachments, shares: @model.getShares())

  _showAttachmentsBox: ->
    @_hasLinks() or @_hasEmailAttachments() or @_hasFacebookAttachments() or @_hasWebchatAttachments()

  _hasLinks: ->
    return false

  _hasEmailAttachments: ->
    @model.isEmail() and @model.hasAttachments?()

  _hasFacebookAttachments: ->
    @model.hasFacebookAttachments?() or @_hasFacebookShares()

  _hasWebchatAttachments: ->
    @model.isWebchat() and @model.hasAttachments?()

  _hasFacebookShares: ->
    @model.isFacebook?() and @model.hasShares?() and @model.getShares().length

  _renderMedia: ->
    @mediaView = new Monitoring.Views.SocialContents.SocialContentMediaView
      el: @$el.find('.sc-media-container')
      socialContent: @model
    @mediaView.render()

  _renderEmailAttachments: ->
    if @_hasEmailAttachments()
      @$el.find('.sc-picture-preview').magnificPopup(type: 'image', closeOnContentClick: true)

  _renderNewsText: ->
    @newsTextView = new Monitoring.Views.SocialContents.SocialContentNewsTextView
      socialContent: @model
    @$el.find('.sc-text-shortener').html(@newsTextView.render().el)

  _renderNewsComment: ->
    @newsCommentView = new Monitoring.Views.SocialContents.SocialContentNewsCommentView
      socialContent: @model
    @$el.find('.sc-text').append(@newsCommentView.render().el)

  _toggleGroups: ->
    @socialContentGroupsView.showTagsEditor()

  _editTags: =>
    @socialContentTagsView.showTagsEditor()

  _hideAllActions: ->
    actions = ['.sc-links', '.sc-actions', '.sc-selector'].join(', ')
    @$el.find(actions).addClass('hidden')
    @$el.find('.row-fluid > div').css('margin', 0)
    @$el.find('.sc-main').removeClass('span8').addClass('span9')

  _isPreviewMode: ->
    @model.get('preview')?

  scrollAttachmentsBackwards: ->
    if @canScrollAttachmentsBackwards()
      @$el.find(".attachments-section").find(".sc-attachment.d-none").last().removeClass("d-none")
      unless @canScrollAttachmentsBackwards()
        @$el.find(".attachment-scroll-backwards").find("i").addClass("disabled")
      @$el.find(".attachment-scroll-forwards").find("i").removeClass("disabled")

  scrollAttachmentsForwards: ->
    if @canScrollAttachmentsForwards()
      @$el.find(".attachments-section").find(".sc-attachment").not(".d-none").first().addClass("d-none")
      unless @canScrollAttachmentsForwards()
        @$el.find(".attachment-scroll-forwards").find("i").addClass("disabled")
      @$el.find(".attachment-scroll-backwards").find("i").removeClass("disabled")


  canScrollAttachmentsBackwards: ->
    hiddenPreviousAttachments = @$el.find(".attachments-section").find(".sc-attachment.d-none")
    return hiddenPreviousAttachments.length > 0

  canScrollAttachmentsForwards: ->
    attachmentSectionWidth = @attachmentSectionVisibleWidth()
    singleAttachmentWidth = @$el.find(".attachments-section").find(".sc-attachment").width()
    visibleAttachments = @$el.find(".attachments-section").find(".sc-attachment").not(".d-none").length
    return (visibleAttachments * singleAttachmentWidth) > attachmentSectionWidth

  attachmentSectionVisibleWidth: ->
    return @$el.find(".sc-text").width() - 140

  displayAttachmentScroll: =>
    if @canScrollAttachmentsForwards()
      @$el.find('.attachment-scroll-backwards').removeClass('d-none')
      @$el.find('.attachment-scroll-forwards').removeClass('d-none')
    else
      @$el.find(".attachment-scroll-backwards").addClass("d-none")
      @$el.find(".attachment-scroll-forwards").addClass("d-none")

  _showModeration: ->
    subType = @model.subType()
    type = @model.type()
    isInbox = @model.groupType() == 'inbox'
    isCustomType = isInbox && !['facebook', 'email', 'clipping', 'youtube'].includes(type)
    isAllowedCommentType = ['ig-comment', 'fb-comment', 'yt-comment', 'tiktok-comment'].includes(subType)
    return isCustomType || isAllowedCommentType
